var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsA: "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    x: "0px",
    y: "0px",
    width: "107px",
    height: "93px",
    viewBox: "-0.4838867 -0.2192383 107 93",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M50.8544922,79.5141602c3.605957,0,6.6577148-0.1855469,10.6323242-0.6494141 c7.03125-1.015625,14.7949219-3.2324219,23.3935547-3.2324219l0.1806641-15.9980469 c0-1.6601563-0.6445313-5.2695313,8.1445313-5.2695313v-6.9355469c-5.2734375,0.4663086-11.3769531,0.2807617-17.4804688,0.2807617 c-6.5625,0-12.8564453,0.1855469-23.0200195-0.0952148v6.5644531c14.1430664-0.0898438,12.9418945,0.8359375,13.034668,5.4550781 c0.1855469,7.765625,0.2783203,8.5078125-0.5517578,9.25c-2.2265625,2.3095703-8.4179688,3.2324219-11.7480469,3.2324219 c-16.9165039,0-20.15625-13.4033203-20.15625-24.2211914c0-12.8564453,1.7602539-27.0947266,21.359375-27.0947266 c14.0556641,0,15.2568359,2.6831055,17.5664063,13.4082031l11.09375,0.3710938l-0.4589844-18.3105469 c-11.09375-1.4794922-18.3105469-2.7758789-28.2011719-2.7758789c-30.6025391,0-42.3481445,10.0805664-42.3481445,34.1210938 C12.2949219,68.4204102,24.128418,79.5141602,50.8544922,79.5141602z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M106.3305664,0H0v91.9995117h106.3305664V0z M101.7016602,87.2827148H4.6191406V4.6191406h97.0825195 V87.2827148z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/G.635dfb69bfd8855a80c96f3f3832a58d.svg";
export { ForwardRef as ReactComponent };